import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FaLink } from 'react-icons/fa';
import { constructURLParams } from 'utils';
import event from 'utils/event';
import { BLACK } from 'root/theme';

import ShareButton from '../ShareButton';

export default class CopyShareButton extends Component {
  onClick = () => {
    const { user, link, source, urlParams, createAlert } = this.props;
    let shareLink = link || `https://www.quizhive.com/referral/${user ? user.username : ``}`;
    shareLink = `${shareLink}?${constructURLParams(urlParams)}`;
    const textField = document.createElement(`textarea`);
    textField.innerText = shareLink;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand(`copy`);
    textField.remove();

    createAlert({
      message: `The sharing link was copied to your clipboard`,
      type: `success`,
    });

    event(`share`, [`click`, `share-clipboard`, source]);
  }

  render() {
    return (
      <ShareButton
        background={BLACK}
        onClick={this.onClick}
        circle={this.props.circle}
      >
        <FaLink size="1.5rem" />
      </ShareButton>
    );
  }
}

CopyShareButton.propTypes = {
  user: PropTypes.object,
  source: PropTypes.string.isRequired,
  link: PropTypes.string,
  createAlert: PropTypes.func.isRequired,
  urlParams: PropTypes.object.isRequired,
  circle: PropTypes.bool,
};

